import { render } from "./Fotter.vue?vue&type=template&id=2ce63b94&scoped=true&ts=true"
import script from "./Fotter.vue?vue&type=script&lang=ts"
export * from "./Fotter.vue?vue&type=script&lang=ts"

import "./Fotter.vue?vue&type=style&index=0&id=2ce63b94&scoped=true&lang=css"

import exportComponent from "/var/www/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce63b94"]])

export default __exports__